var de = require('apexcharts/dist/locales/de.json')
var en = require('apexcharts/dist/locales/en.json')
var hr = require('apexcharts/dist/locales/hr.json')
var ru = require('apexcharts/dist/locales/ru.json')
var es = require('apexcharts/dist/locales/es.json')
var tr = require('apexcharts/dist/locales/tr.json')
var cs = require('apexcharts/dist/locales/cs.json')

export const ApexChartsLocale = [
  de,
  en,
  hr,
  ru,
  es,
  tr,
  cs
]
